/** @file Draws one pose as a stick skeleton (line per bone, dot per joint) in a single tint. */
import type { Pose } from '@pose2d/core/types';
import type { Sink } from '../draw/createSink';
import { emitDisc } from '../draw/emitDisc';
import { emitLine } from '../draw/emitLine';
import type { OverlayInput } from '../overlayInput';
import { boneSegment } from './boneSegment';

const seg = new Float64Array(4);

/** Bones of kind 'bone' of `pose` (laid out like `input.data`; missing bones are skipped as non-finite). */
export function drawGhostBones(sink: Sink, input: OverlayInput, pose: Pose, color: number): void {
  input.data.bones.forEach((bone, i) => {
    if (bone.kind !== 'bone') return;
    boneSegment(pose, input.camera, i, bone.length, seg);
    emitLine(sink, seg, 2, color);
    emitDisc(sink, seg[0] ?? NaN, seg[1] ?? NaN, 2.5, color);
  });
}
